import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { CHAPTERS } from "../data/content";
import { Reveal, LineReveal } from "./Reveal";

const Chapter = ({ c, i }) => {
  const flip = i % 2 === 1;
  return (
    <div className={`grid lg:grid-cols-12 gap-10 lg:gap-16 items-center py-20 lg:py-28 border-t border-[var(--line)]`} data-testid={`manifesto-chapter-${i}`}>
      <div className={`lg:col-span-6 ${flip ? "lg:order-2" : ""}`}>
        <Reveal y={10}>
          <div className="flex items-center gap-4 mb-8">
            <span className="font-display text-6xl lg:text-7xl font-light gold-text leading-none">{c.n}</span>
            <span className="hairline flex-1 max-w-[120px]" />
            <span className="eyebrow">Kapitel</span>
          </div>
        </Reveal>
        <LineReveal lines={c.title.split(" ").length > 2 ? [c.title.split(" ").slice(0, 2).join(" "), c.title.split(" ").slice(2).join(" ")] : [c.title]} className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.02] tracking-tight" />
        <Reveal delay={0.2} y={16}>
          <p className="mt-8 font-display italic text-xl lg:text-2xl text-[var(--gold-3)] leading-snug max-w-lg">{c.lead}</p>
          <p className="mt-5 text-[var(--muted)] leading-relaxed max-w-lg">{c.text}</p>
          <ul className="mt-8 grid sm:grid-cols-2 gap-x-8 gap-y-3 max-w-lg">
            {c.list.map((l) => (
              <li key={l} className="flex items-center gap-3 text-sm text-[var(--text)]">
                <Check size={14} className="text-[var(--gold)] shrink-0" /> {l}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
      <div className={`lg:col-span-6 ${flip ? "lg:order-1" : ""}`}>
        <motion.figure
          initial={{ opacity: 0, scale: 0.94, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          viewport={{ once: true, margin: "-12% 0px" }}
          transition={{ duration: 1.3, ease: [0.22, 1, 0.36, 1] }}
          className={`frame frame-corner border border-[var(--line)] ${c.aspect || "aspect-[4/3] lg:aspect-[5/4]"} ${c.light ? "bg-white" : ""}`}
        >
          <img src={c.img} alt={c.caption} className={`absolute inset-0 w-full h-full ${c.light ? "object-contain p-6 lg:p-8" : `object-cover ${c.pos || "object-center"}`}`} loading="lazy" />
          {!c.light && <div className="veil" />}
          <figcaption className={`absolute bottom-5 left-5 font-mono text-[0.6rem] tracking-[0.2em] uppercase px-3 py-2 ${c.light ? "bg-[var(--bg)] text-[var(--gold)]" : "text-[var(--gold)]"}`}>
            {c.caption}
          </figcaption>
        </motion.figure>
      </div>
    </div>
  );
};

export const Manifesto = () => (
  <section id="manifest" className="relative py-20 lg:py-28 bg-[var(--bg-2)]" data-testid="manifesto-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <Reveal>
        <p className="eyebrow mb-6">Warum Visualisierung</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light max-w-3xl leading-tight">
          Drei Prinzipien, nach denen jedes Bild bei Salgin Solutions entsteht.
        </h2>
      </Reveal>
      <div className="mt-16">
        {CHAPTERS.map((c, i) => <Chapter key={c.n} c={c} i={i} />)}
      </div>
    </div>
  </section>
);
